export const getPath = (item, path) => {
  try{
    if (item.buttonType) {
      switch (item.buttonType) {
        case 'URL':
          return item.url;
        case 'Page':
          if (item.page._type == 'home') {
            return '/';
          } else {
            return item.page.slug.current;
          }
        case 'Page Internal':
          if (item.page._type == 'home') {
            return '/';
          } else {
            return item?.page?.slug?.current;
          }
        case 'Collection':
          return `collections/${item?.collection?.slug?.current}`;
        case 'Tags':
          return `etiqueta-producto/${item?.labels?.slug?.current}`;
        case 'Page Category':
          if (item.category) {
            if (item.category?.parent?.parent) {
              return `categoria-producto/${item?.category?.parent?.slug?.current}/${item?.category?.parent?.parent?.slug?.current}/${item?.category?.slug?.current}`;
            }
            if (item.category?.parent) {
              return `categoria-producto/${item?.category?.parent?.slug?.current}/${item?.category?.slug?.current}`;
            }
            return `categoria-producto/${item?.category?.slug?.current}`;
          }
          if (item.pageCategory?._type == 'categorytags') {
            if (item.pageCategory?.parent) {
              return `categoria-producto/${item?.pageCategory?.parent?.slug?.current}/${item?.pageCategory?.slug?.current}`;
            } else {
              return `categoria-producto/${item?.pageCategory?.slug?.current}`;
            }
          }
          if (item.categorytags) {
            return `categoria-producto/${item?.parent?.parent?.slug?.current}/${item?.parent?.slug?.current}/${item?.slug?.current}`;
          } else {
            return '/';
          }
        case 'Page Category / Tags':
          if (item.category) {
            if (item.category?.parent) {
              return `categoria-producto/${item?.category?.parent?.slug?.current}/${item?.category?.slug?.current}`;
            }
            return `categoria-producto/${item?.category?.slug.current}`;
          }
          if (item.pageCategory?._type == 'categorytags') {
            if (item.pageCategory?.parent) {
              return `categoria-producto/${item?.pageCategory?.parent?.slug?.current}/${item?.pageCategory?.slug?.current}`;
            } else {
              return `categoria-producto/${item?.pageCategory?.slug?.current}`;
            }
          } else {
            return '/';
          }
        default:
          return '/';
      }
    }
    if (item.redirectionType) {
      switch (item.redirectionType) {
        case 'Collection':
          return `coleccion/${item?.collection?.slug?.current}`;
        case 'Page Category':
          if (item.categorytags?._type == 'categorytags') {
            if (item.categorytags.parent) {
              return `categoria-producto/${item?.categorytags?.parent?.slug?.current}/${item?.categorytags?.slug?.current}`;
            } else {
              return `categoria-producto/${item?.categorytags?.slug?.current}`;
            }
          }
          if (item.categorytags?._type == 'category') {
            return `categoria-producto/${item?.categorytags?.slug?.current}`;
          }
          if (item.categorytags?._type == 'categorytags-child') {
            if (item.categorytags.parent) {
              return `categoria-producto/${item?.categorytags?.parent?.parent?.slug?.current}/${item?.categorytags?.parent?.slug?.current}/${item?.categorytags?.slug?.current}`;
            }
          }

          return '/';
        case 'Page Category / Tags':
          if (item.categorytags?._type == 'categorytags-child') {
            if (item.categorytags.parent) {
              return `categoria-producto/${item?.categorytags?.parent?.parent?.slug?.current}/${item?.categorytags?.parent?.slug?.current}/${item?.categorytags?.slug?.current}`;
            }
          }

          if (item.categorytags?._type == 'categorytags') {
            if (item.categorytags.parent) {
              return `categoria-producto/${item?.categorytags?.parent?.slug?.current}/${item?.categorytags?.slug?.current}`;
            } else {
              return `categoria-producto/${item.categorytags?.slug?.current}`;
            }
          }
          if (item.categorytags?._type == 'category') {
            return `categoria-producto/${item?.categorytags?.slug?.current}`;
          }
          if (item.categorytags?._type == 'label') {
            return `etiqueta-producto/${item?.categorytags?.slug?.current}`;
          }
          return '/';
        case 'Product':
          return `producto/${item?.product?.store?.slug?.current}`;
        case 'Blog':
          return item?.blog?.slug?.current;
        case 'Page':
          if (item.page._type == 'home') {
            return '/';
          } else {
            return item.page.slug.current;
          }
        case 'Tags':
          return `etiqueta-producto/${item?.labels?.slug?.current}`;
        case 'URL':
          return item.url;
        case 'Downloadable':
            return item?.downloadable?.file?.asset?.url;
        default:
          return '/';
      }
    }

    if (item.type) {
      switch (item.type) {
        case 'URL':
          return item.url;
        case 'Page':
          if (item.page._type == 'home') {
            return '/';
          } else {
            return item?.page?.slug?.current;
          }
        case 'Collection':
          return `coleccion/${item?.collection?.slug?.current}`;
        case 'Tags':
          return `etiqueta-producto/${item?.labels?.slug.current}`;
        case 'Page Category / Tags':
          if (item.category) {
            if (item.category?.parent) {
              return `categoria-producto/${item?.category?.parent.slug.current}/${item.category?.slug?.current}`;
            }
            return `categoria-producto/${item?.category?.slug.current}`;
          }
          if (item.pageCategory?._type == 'categorytags') {
            if (item.pageCategory?.parent) {
              return `categoria-producto/${item?.pageCategory?.parent?.slug?.current}/${item?.pageCategory?.slug?.current}`;
            } else {
              return `categoria-producto/${item?.pageCategory?.slug?.current}`;
            }
          } else {
            return '/';
          }
        case 'Page Category':
          if (item.category) {
            if (item.category?.parent?.parent) {
              return `categoria-producto/${item?.category?.parent?.slug?.current}/${item?.category?.parent?.parent?.slug?.current}/${item.category?.slug?.current}`;
            }
            if (item.category?.parent) {
              return `categoria-producto/${item?.category?.parent?.slug?.current}/${item.category?.slug?.current}`;
            }
            return `categoria-producto/${item?.category?.slug.current}`;
          }
          if (item.pageCategory?._type == 'categorytags') {
            if (item.pageCategory?.parent) {
              return `categoria-producto/${item?.pageCategory?.parent?.slug?.current}/${item?.pageCategory?.slug?.current}`;
            } else {
              return `categoria-producto/${item?.pageCategory?.slug?.current}`;
            }
          } else {
            return '/';
          }
        case 'Product':
          return `coleccion/${item?.slug?.current}`;
        default:
          return '/';
      }
    }
    if (item._type) {
      switch (item._type) {
        case 'collecciones':
          return `coleccion/${item?.slug?.current}`;
        case 'list':
          if (item.categorytags) {
            return `categoria-producto/${item?.parent?.parent?.slug?.current}/${item?.parent?.slug?.current}/${item?.slug?.current}`;
          } else {
            return '/';
          }
        case 'categorytags-child':
          if (item.parent) {
            return `categoria-producto/${item?.parent?.parent?.slug?.current}/${item?.parent?.slug?.current}/${item?.slug?.current}`;
          }
        case 'categorytags':
          try{
            if (item?.parent) {
              return `categoria-producto/${item?.parent?.slug?.current}/${item?.slug?.current}`;
            } else {
              return `categoria-producto/${item?.slug?.current}`;
            }
          }catch(e){

          }
        case 'label':
            return `etiqueta-producto/${item?.slug?.current}`;
      
        case 'category': {
          return `categoria-producto/${item?.slug?.current}`;
        }
        default:
          return '#';
      }
    }
    return '/';
  }catch(e){
    console.error('Error in getPath()', e);
    return '/';
  }
};

export const getPathButtonsCategory = (item) => {
  if(item._type == 'label'){
    return 'etiqueta-producto/'+ item?.slug?.current;
  }else if(item._type == 'categorytags'){
    let info = item?.parent?.slug?.current;
    return 'categoria-producto/'+info+'/'+ item?.slug?.current;
  }else if(item._type == 'category'){
    return 'categoria-producto/'+ item?.slug?.current;
  }

  return '';
}